import { useState } from "react";

const PasswordChangeHistory = () => {
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const ProfitLossData = [
    {
      DateTime: "15-07-2025 09:50",
      remark: "Pass Changed",
    },
  ];

  return (
    <div className="mx-auto bg-white rounded-t-lg  mx-1">
      <div className="mt-4 border-2 border-gray-300">
        <div className="p-1.5 rounded-t bg-gradient-to-b from-[#2E4B5E] to-[#243A48]">
          <h2 className="text-white text-sm font-semibold">
            Password Change History
          </h2>
        </div>
        <div className="bg-white">
          <div className="overflow-x-auto p-3">
            <div className="bg-white px-4 py-3 flex items-center justify-center border-b border-gray-200">
              <div className="flex items-center space-x-2">
                <span className="text-black dark:text-white text-sm">Show</span>
                <select
                  value={entriesPerPage}
                  onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:border-blue-500"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span className="text-black dark:text-white text-sm">entries</span>
              </div>
            </div>
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-[#E0E6E6] text-sm">
                  <th
                    className="px-4 py-3 text-left text-gray-950 font-semibold border-r border-gray-300"
                    scope="col"
                  >
                    Date/Time
                  </th>
                  <th
                    className="px-4 py-3 text-left text-gray-950 font-semibold border-r border-gray-300"
                    scope="col"
                  >
                    Remark
                  </th>
                </tr>
              </thead>
              <tbody>
                {ProfitLossData.map((row, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-300 last:border-b-0 text-xs"
                  >
                    <td className="px-4 py-3 text-gray-950 border-r border-gray-300 font-semibold">
                      {row.DateTime}
                    </td>
                    <td className="px-4 py-3 text-gray-950 border-r border-gray-300 font-semibold">
                      {row.remark}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="bg-white px-4 py-3 border-t border-gray-200">
              <div className="flex flex-col justify-center items-center space-y-4">
                <div className="text-sm text-black dark:text-white">
                  Showing 1 to {Math.min(entriesPerPage, ProfitLossData.length)}{" "}
                  of {ProfitLossData.length} entries
                </div>
                <div className="flex items-center space-x-2">
                  <button className="px-3 py-1 text-sm text-gray-500 rounded hover:bg-gray-200 transition-colors">
                    First
                  </button>
                  <button className="px-3 py-1 text-sm text-gray-500 rounded hover:bg-gray-200 transition-colors">
                    Previous
                  </button>
                  <button className="px-3 py-1 text-sm text-gray-500 rounded hover:bg-gray-200 transition-colors">
                    Next
                  </button>
                  <button className="px-3 py-1 text-sm text-gray-500 rounded hover:bg-gray-200 transition-colors">
                    Last
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordChangeHistory;
